<div class="row mb-5"></div>
<div class="row mb-5"></div>
<!-- <div class="row mb-5"></div> -->
<!-- <div class="row mb-5"></div> -->
  <div class="mask strong">

      <div class="container-md-fluid d-flex align-items-center justify-content-center h-100">

          <div class="row d-flex justify-content-center text-center">

              <div class="col-md-12">

                  <!-- Heading -->

                  <h1 class="display-4 black-text pt-5 mb-2"  style = "font-family: Black Ops One" >Flight Risk Assesment</h1>

                  <!-- Description -->
                  <div class="row mb-5"></div>
                 <div class="col-md-12">
                  <a  routerLink="/assesments"><button type="button" class="btn btn-danger btn-lg btn-rounded" mdbWavesEffect>Start Assesment</button></a>
                </div>


              </div>

              <div class="col-md-5">
                <h4 class="display-6 black-text pt-5 mb-2"  style = "font-family: Black Ops One">10 question quiz get 8 or more questions correct to pass!</h4>
              </div>

      </div>

  </div>
